import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAw = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#418fde", d: "M0 0h27v18H0V0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffd100", d: "M0 12h27v1H0v1h27v1H0v-3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#EF3340", stroke: "#FFF", strokeWidth: 0.2, strokeMiterlimit: 10, d: "M4.625 3.375L4 1.35l-.625 2.025L1.35 4l2.025.625L4 6.65l.625-2.025L6.65 4z" }));
const ForwardRef = forwardRef(SvgAw);
const Memo = memo(ForwardRef);
export default Memo;
